import Cache from 'root/cache';
import Collection_History from 'collection/history';
import View from 'view/base';
import View_Feedback_History from 'view/feedback_history';

export default View.extend({
    is_loaded: false,

    views: {
        history: {}
    },

    initialize: function(options) {
    },

    load: function() {
        Cache.app.request({
            action: 'history/loadFeedbackHistory',
            data: {feedback_id: this.model.id},
            success: (response) => {
                this.$el.empty();

                var history_collection = new Collection_History(response);

                history_collection.each((model) => {
                    this.views.history['_' + model.id] = new View_Feedback_History({model: model});
                    this.views.history['_' + model.id].render().$el.appendTo(this.$el);
                });

                if (!history_collection.length) {
                    this.$el.html('<div class="text-info italic">No activities</div>');
                }
            }
        });
    },

    render: function() {
        var content = '<div class="text-info">Loading...</div>';

        this.$el.html(content);

        return this;
    }
});